import React, { useState } from "react";

const Map = ({
  selectedMaster,
  onSlaveClick
}) => {

  const [hoveredMarker, setHoveredMarker] = useState(null);
  
  // Extrai slaves do master selecionado
  const slaves = selectedMaster?.slaves || [];



  return (
    <div style={{ height: "100%", width: "100%", overflow: 'hidden' }}>
      {/* Container do mapa com imagem de fundo */}
      <div 
        style={{
          position: 'relative',
          width: '100%',
          height: '100%',
          backgroundImage: 'url("/images/silo-bolsa-2.jpg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        {/* Renderizar slaves do master selecionado */}
        {slaves.length > 0 ? (
          slaves.map((slave, index) => {
            const [longitude, latitude] = slave.location.coordinates;
            const serial = slave.serialnumber;
            
            if (!latitude || !longitude || !serial) return null;

            // Organiza em grid: até 10 slaves por linha
            const SLAVES_POR_LINHA = 10;
            const MARGEM_ESQUERDA = 2; // 2% da lateral esquerda
            const MARGEM_TOPO = 3; // 3% do topo
            const ESPACAMENTO_HORIZONTAL = 9; // 9% entre cada slave horizontalmente
            const ESPACAMENTO_VERTICAL = 35; // 35% entre cada linha verticalmente
            
            const coluna = index % SLAVES_POR_LINHA;
            const linha = Math.floor(index / SLAVES_POR_LINHA);
            
            const leftPercent = MARGEM_ESQUERDA + (coluna * ESPACAMENTO_HORIZONTAL);
            const topPercent = MARGEM_TOPO + (linha * ESPACAMENTO_VERTICAL);

            return (
              <div
                key={`slave-${serial}`}
                style={{
                  position: 'absolute',
                  left: `${leftPercent}%`,
                  top: `${topPercent}%`,
                  zIndex: 100
                }}
                onMouseEnter={() => setHoveredMarker(serial)}
                onMouseLeave={() => setHoveredMarker(null)}
              >
                {/* Marcador do slave */}
                <div
                  style={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer'
                  }}
                  onClick={() => onSlaveClick(serial)}
                >
                  {/* Imagem do Silo-Bolsa */}
                  <img
                    src="/images/silobag.png"
                    alt={`Slave ${serial}`}
                    style={{ width: '100px', height: '450px' }}
                  />
                  {/* Marcador circular sobreposto - centralizado verticalmente */}
                  <div
                    style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                      backgroundColor: '#28a745', // Verde (online)
                      border: "3px solid white",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "16px",
                      fontWeight: "bold",
                      color: "white",
                      transition: 'all 0.2s ease'
                    }}
                  >
                    {serial.slice(-3)}
                  </div>

                  {/* Tooltip simples em hover - posicionado acima do círculo */}
                  {hoveredMarker === serial && (
                    <div style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, calc(-50% - 40px))', // Posiciona acima do círculo
                      background: 'rgba(33, 37, 41, 0.95)',
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                      borderRadius: '8px',
                      padding: '8px 12px',
                      fontSize: '0.8rem',
                      color: 'white',
                      whiteSpace: 'nowrap',
                      zIndex: 999,
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                      pointerEvents: 'none'
                    }}>
                      {serial}
                      <div style={{
                        position: 'absolute',
                        top: '100%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        width: '0',
                        height: '0',
                        borderLeft: '6px solid transparent',
                        borderRight: '6px solid transparent',
                        borderTop: '6px solid rgba(33, 37, 41, 0.95)'
                      }} />
                    </div>
                  )}
                </div>
              </div>
            );
          })
        ) : (
          /* Mensagem quando não há slaves */
          <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            background: 'rgba(33, 37, 41, 0.95)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            borderRadius: '12px',
            padding: '24px 32px',
            textAlign: 'center',
            color: 'white',
            zIndex: 100
          }}>
            <div style={{ fontSize: '3rem', marginBottom: '12px' }}>📡</div>
            <h5 style={{ marginBottom: '8px' }}>Nenhum slave encontrado</h5>
            <p style={{ margin: 0, opacity: 0.8, fontSize: '0.9rem' }}>
              {selectedMaster ? 'Este master não possui slaves cadastrados' : 'Selecione um master na lista'}
            </p>
          </div>
        )}

        </div>
    </div>
  );
};

export default Map;
